export const GET_WITHDRAW_REQUEST = 'GET_WITHDRAW_REQUEST';
export const ACCEPT_WITHDRAW_REQUEST = "ACCEPT_WITHDRAW_REQUEST"
export const DECLINE_WITHDRAW_REQUEST = "DECLINE_WITHDRAW_REQUEST"
export const GET_WITHDRAW_STATS_DATA = "GET_WITHDRAW_STATS_DATA"